import { Add, AddCircleOutline, Close, Search } from "@mui/icons-material";
import {
  Box,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemText,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { PolygonTypes } from "../polygonTypes";

const Actions = {
  MULCH: "mulch",
  FERTILIZE: "fertilize",
  WATER: "water",
  PAVE: "pave",
};

const ActionsTogether = [
  {
    name: "mulch with cedar 2 inches deep",
    type: Actions.MULCH,
    unit: "sqft",
    resources: [
      {
        name: "cedar mulch",
        type: Actions.MULCH,
        image: "https://www.homedepot.ca/product_images/1001004761.jpg",
        price: 10.99,
        qty: 2,
      },
      {
        name: "labour",
        type: Actions.MULCH,
        image: "https://www.homedepot.ca/product_images/1001004761.jpg",
        price: 10.99,
        qty: 0.5,
      },
      {
        name: "delivery",
        type: Actions.MULCH,
        image: "https://www.homedepot.ca/product_images/1001004761.jpg",
        price: 200,
        qty: 1,
      },
      {
        name: "setup and cleanup labour",
        type: Actions.MULCH,
        image: "https://www.homedepot.ca/product_images/1001004761.jpg",
        qty: 0.5,
      },
    ],
  },
];

// EASY SOLUTION FOR NOW
/**
 * Instead of making all these custom solutions clicks now, yadda yadda
 * just make a list of options with all the information already set.
 * For example have an action "mulch with cedar 2 inches deep" and have the resources
 * already listed (the mulch type, labour, etc.). Then just looks up the price in the db
 * and adds it to the quote.
 */

const actionOptions = {
  [Actions.MULCH]: [
    {
      mulchType: [],
      mulchDepth: "2",
    },
  ],
};

const resources = [
  {
    name: "cedar mulch bag",
    type: Actions.MULCH,
    image: "https://www.homedepot.ca/product_images/1001004761.jpg",
    price: 10.99,
    qty: 0.05663369, //cubic meters
  },
  {
    name: "Cypress Mulch",
    type: Actions.MULCH,
    image: "https://www.homedepot.ca/product_images/1001004761.jpg",
    price: 123.9,
    qty: 1,
  },
];

function getMulchPrice(name, area, depth = 0.02) {
  let mulch = resources.find((resource) => resource.name === name);
  if (!mulch) return 0;
  return mulch.price * ((area * depth) / mulch.qty);
}

function getMulchVolume(area, depth = 0.02) {
  return area * depth;
}

function QuoteTotal({ subTotal, tax, total }) {
  total = subTotal + subTotal * tax;
  return (
    <Box>
      <List>
        <ListItem style={{ cursor: "pointer" }}>
          <div style={{ flexGrow: 1 }}></div>

          <ListItemText
            style={{ textAlign: "right" }}
            primary={`$${subTotal.toFixed(2)}`}
            secondary={"Subtotal"}
          />
        </ListItem>
        {/* <ListItem style={{ cursor: "pointer" }}>
          <div style={{ flexGrow: 1 }}></div>

          <ListItemText
            style={{ textAlign: "right" }}
            primary={`$${tax.toFixed(2)}`}
            secondary={"Tax"}
          />
        </ListItem> */}
        <ListItem style={{ cursor: "pointer" }}>
          <ListItemText
            primary={"Total"}
            secondary={`Tax: $${(tax * subTotal).toFixed(2)}`}
          />
          <div style={{ flexGrow: 1 }}></div>

          <ListItemText
            style={{ textAlign: "right" }}
            primary={`$${total.toFixed(2)}`}
            secondary={"incl. tax"}
          />
        </ListItem>
      </List>
    </Box>
  );
}

const costPerTrip = 50 * 0.5;
const maxVolumnePerTrip = 1;

const volumePerWheelbarrow = 0.1;
const wage = 50;
/**
 * load time 1 min
 * walk time 2 min
 * unload time 1 min
 * spread 1 min
 */
const hoursPerWheelBarrow = 5 / 60;

const hoursInDay = 8;
const packupTime = 0.5;
const setupTime = 0.5;
const activeHoursPerDay = hoursInDay - packupTime;
const applyHoursPerWheelbarrow = 7 / 60;

function mulchApplicationCost(area) {
  // Calculate application hours and total
  let totalVolumeOfMulch = getMulchVolume(area);
  let numberWheelbarrowTrips = Math.ceil(
    totalVolumeOfMulch / volumePerWheelbarrow
  );
  let applicationHours =
    numberWheelbarrowTrips * hoursPerWheelBarrow +
    applyHoursPerWheelbarrow * numberWheelbarrowTrips;
  console.log(numberWheelbarrowTrips, applicationHours, "application hours");
  let applicationTotal = applicationHours * wage;

  // Calculate setup and packup time
  let numDays = Math.ceil(applicationHours / activeHoursPerDay);
  let setupPackupHours = numDays * (packupTime + setupTime);
  let setupPackupTotal = numDays * setupPackupHours * wage;

  return {
    numberWheelbarrowTrips,
    applicationHours,
    applicationTotal,
    setupPackupHours,
    setupPackupTotal,
    numDays,
  };
}

function MulchApplication({
  numberWheelbarrowTrips,
  applicationHours,
  applictionTotal,
  setupPackupHours,
  setupPackupTotal,
  numDays,
}) {
  console.log(
    numberWheelbarrowTrips,
    applicationHours,
    applictionTotal,
    setupPackupHours,
    setupPackupTotal,
    numDays,
    "mulch application"
  );
  return (
    <Box>
      <List>
        <ListItem style={{ cursor: "pointer" }}>
          <ListItemText
            primary={"Application"}
            secondary={`Wheelbarrow Loads: ${numberWheelbarrowTrips}`}
          />
          <div style={{ flexGrow: 1 }}></div>

          <ListItemText
            style={{ textAlign: "right" }}
            primary={`$${applictionTotal.toFixed(2)}`}
            secondary={`Time: ${applicationHours.toFixed(2)} hours`}
          />
        </ListItem>

        <ListItem style={{ cursor: "pointer" }}>
          <ListItemText
            primary={"Site visits"}
            secondary={`Days: ${numDays}`}
          />
          <div style={{ flexGrow: 1 }}></div>

          <ListItemText
            style={{ textAlign: "right" }}
            primary={`$${setupPackupTotal.toFixed(2)}`}
            secondary={`Setup: ${setupPackupHours.toFixed(2)} hours`}
          />
        </ListItem>
      </List>
    </Box>
  );
}

function MulchDelivery({ totalCost, totalVolumeOfMulch, numberTrips }) {
  return (
    <Box>
      <List>
        <ListItem style={{ cursor: "pointer" }}>
          <ListItemText
            primary={"Delivery"}
            secondary={`Number of trips: ${numberTrips}`}
          />
          <div style={{ flexGrow: 1 }}></div>

          <ListItemText
            style={{ textAlign: "right" }}
            primary={`$${totalCost.toFixed(2)}`}
            secondary={`Volume: ${totalVolumeOfMulch.toFixed(2)} m^3`}
          />
        </ListItem>
      </List>
    </Box>
  );
}

const QuoteMulch = ({
  allResources = [],
  allPlants = [],
  areas = [],
  onClose,
  open = false,
  title = "Quote",
  mPerPixel,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  // Selected options
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedAction, setSelectedAction] = useState(null);
  const searchRef = useRef(null);

  let mulchableAreas = areas.filter(
    (area) => area.type() === PolygonTypes.GARDEN
  );

  useEffect(() => {
    if (isSearching && searchRef.current) {
      searchRef.current.focus();
    }
  }, [isSearching]);

  const handleAddActionClicked = () => {
    setIsSearching(true);
  };

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleSearchClose = () => {
    setIsSearching(false);
    setSearchValue("");
  };

  // const filteredActions = Object.values(Actions).filter((action) =>
  //   action.toLowerCase().includes(searchValue.toLowerCase())
  // );

  const filteredResources = resources.filter((resource) =>
    resource.name.toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleActionSelect = (action) => {
    setSelectedAction(action);
    setIsSearching(false);
    setSearchValue("");
  };

  const handleAreaAdd = (area) => {};
  const handlePlantClick = (plant) => {};

  const totalAreaOfMulch = mulchableAreas.reduce(
    (acc, area) => acc + area.area(mPerPixel),
    0
  );

  const totalCostOfMulch = getMulchPrice(selectedAction, totalAreaOfMulch);

  const applicationCost = 0;
  const siteVisitCost = 0;

  let numberTrips = Math.ceil(
    getMulchVolume(totalAreaOfMulch) / maxVolumnePerTrip
  );
  const deliveryCost = costPerTrip * numberTrips;
  const {
    numberWheelbarrowTrips,
    applicationHours,
    applicationTotal,
    setupPackupHours,
    setupPackupTotal,
    numDays,
  } = mulchApplicationCost(totalAreaOfMulch);
  const totalVolumeOfMulch = getMulchVolume(totalAreaOfMulch);

  const totalCost =
    totalCostOfMulch + deliveryCost + applicationCost + siteVisitCost;

  return (
    <Slide direction="up" in={open} mountOnEnter unmountOnExit>
      <Box
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          height: "66%",
          backgroundColor: "#fff",
          zIndex: 1300,
          overflowX: "auto",
          padding: "16px",
          display: "flex",
          // alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Stack direction={"row"}>
          <Typography variant="h5" style={{ marginBottom: "16px" }}>
            {title} for {selectedAction || "..."}
          </Typography>

          <div style={{ flexGrow: 1 }}></div>
          {isSearching ? (
            <IconButton onClick={handleSearchClose}>
              <Close />
            </IconButton>
          ) : (
            <>
              <IconButton onClick={handleAddActionClicked}>
                <AddCircleOutline />
              </IconButton>
              <IconButton onClick={onClose}>
                <Close />
              </IconButton>
            </>
          )}
        </Stack>

        {isSearching ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderRadius: 2,
              backgroundColor: "#f2f2f2",
              padding: "2px 4px",
              marginBottom: "16px",
            }}
          >
            <IconButton sx={{ p: "10px" }} aria-label="search">
              <Search />
            </IconButton>
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search for an action"
              value={searchValue}
              onChange={handleSearchChange}
              inputRef={searchRef}
            />
          </Box>
        ) : null}

        <List>
          {isSearching
            ? filteredResources.map((plant) => (
                <ListItem
                  key={plant}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleActionSelect(plant.name)}
                >
                  <ListItemText primary={plant.name} />
                </ListItem>
              ))
            : mulchableAreas.map((plant, i) => (
                <Fragment key={i}>
                  <ListItem key={plant.name()} style={{ cursor: "pointer" }}>
                    <ListItemText
                      primary={plant.name()}
                      secondary={`Area: ${getMulchVolume(
                        plant.area(mPerPixel)
                      ).toFixed(2)} m^3`}
                    />
                    <div style={{ flexGrow: 1 }}></div>

                    <ListItemText
                      style={{ textAlign: "right" }}
                      primary={`$${getMulchPrice(
                        selectedAction,
                        plant.area(mPerPixel)
                      ).toFixed(2)}`}
                      // secondary={`Area: ${plant.area().toFixed(2)} sqft`}
                    />
                  </ListItem>
                </Fragment>
              ))}
        </List>
        <MulchDelivery
          totalCost={deliveryCost}
          totalVolumeOfMulch={totalVolumeOfMulch}
          numberTrips={numberTrips}
        />
        <MulchApplication
          numberWheelbarrowTrips={numberWheelbarrowTrips}
          applicationHours={applicationHours}
          applictionTotal={applicationTotal}
          setupPackupHours={setupPackupHours}
          setupPackupTotal={setupPackupTotal}
          numDays={numDays}
        />
        <QuoteTotal subTotal={totalCost} tax={0.15} total={totalCost} />
      </Box>
    </Slide>
  );
};

export default QuoteMulch;
